import logoMark from "@/assets/brand/logo-mark.webp";
import type { BlogPostSummary, BlogRouteId } from "@/blog/types";

/* Articles without a cover get a lit brand plate, tinted per route. */
const PLATES: Record<BlogRouteId, string> = {
  instagram: "bg-[linear-gradient(135deg,#dbe9e8,#f4f8f8)]",
  web: "bg-[linear-gradient(135deg,#1a3c5e,#2c5a82)]",
  reservas: "bg-[linear-gradient(135deg,#e7f2f1,#c9dfdd)]",
  automatizacion: "bg-[linear-gradient(135deg,#122c46,#1f4a70_60%,#4f8f8b)]",
  optimizacion: "bg-[linear-gradient(135deg,#f1f5f8,#dde7ee)]",
};

/** Uploaded covers come in two widths: `…-1600.webp` and `…-800.webp`. */
function srcSet(url: string): string | undefined {
  const match = /-1600\.(webp|jpg|png)$/.exec(url);
  if (!match) return undefined;
  return `${url.replace(/-1600\.(webp|jpg|png)$/, `-800.${match[1]}`)} 800w, ${url} 1600w`;
}

export function BlogCover({
  post,
  sizes = "(min-width: 1024px) 30vw, (min-width: 640px) 45vw, 100vw",
  priority = false,
  className = "",
}: {
  post: Pick<BlogPostSummary, "coverUrl" | "coverAlt" | "route">;
  sizes?: string;
  priority?: boolean;
  className?: string;
}) {
  if (post.coverUrl) {
    return (
      <img
        src={post.coverUrl}
        srcSet={srcSet(post.coverUrl)}
        sizes={sizes}
        alt={post.coverAlt}
        width={1600}
        height={900}
        loading={priority ? "eager" : "lazy"}
        fetchPriority={priority ? "high" : undefined}
        decoding="async"
        className={`h-full w-full object-cover ${className}`}
      />
    );
  }
  return (
    <div aria-hidden="true" className={`grid h-full w-full place-items-center ${PLATES[post.route]} ${className}`}>
      <img src={logoMark} alt="" width={256} height={256} className="w-[22%] max-w-24 opacity-90" />
    </div>
  );
}
